<template>
  <div>
    <div class="p-8 bg-gray-800">
      <div class="max-w-7xl mx-auto">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex-1 min-w-0">
            <h5 class="text-xs tracking-wide font-medium uppercase text-gray-400">Products</h5>
            <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl flex gap-1 items-center">
              <RouterLink
                :to="{ name: 'admin.products.memberships' }"
                class="text-blue-500 hover:text-blue-700 inline-flex"
                >Memberships</RouterLink
              >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6 inline-flex mt-1.5"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                /></svg
              >New
            </h2>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4 space-x-2">
            <!-- Actions -->
          </div>
        </div>
      </div>
    </div>
    <div class="p-8">
      <div class="max-w-7xl mx-auto">
        <div>
          <BaseVeeForm :action="createProduct">
            <template #default="formProps">
              <BaseCard>
                <BaseCardBody clear-padding>
                  <div class="grid grid-cols-2">
                    <div class="space-y-6 p-8">
                      <BaseFormTextFieldWithValidator
                        v-model="product.name"
                        :disabled="formProps.isPending"
                        v-bind="productNameInputProps"
                      />
                      <BaseFormTextareaFieldWithValidator
                        v-model="product.description"
                        :disabled="formProps.isPending"
                        v-bind="productDescriptionInputProps"
                      />
                    </div>
                  </div>
                </BaseCardBody>
                <BaseCardFooter gray class="flex justify-end">
                  <BaseButton primary :disabled="formProps.isPending || formProps.invalid"
                    >Create product</BaseButton
                  >
                </BaseCardFooter>
              </BaseCard>
            </template>
          </BaseVeeForm>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { membershipProductsClient } from '@/api/clients/admin';

export default {
  data() {
    return {
      product: {
        name: '',
        description: '',
      },
    };
  },
  computed: {
    productNameInputProps() {
      return {
        validator: {
          name: 'name',
          vid: 'name',
          rules: { required: true },
        },
        field: {
          id: 'product-name',
          label: 'Product name',
        },
      };
    },
    productDescriptionInputProps() {
      return {
        validator: {
          name: 'description',
          vid: 'description',
          rules: { required: false },
        },
        field: {
          id: 'product-description',
          label: 'Product description',
        },
      };
    },
  },
  methods: {
    createProduct() {
      return membershipProductsClient.store(this.product).then(() => {
        this.$router.replace({
          name: 'admin.products.memberships',
        });
      });
    },
  },
};
</script>
